<template>
  <div class="v-stack h-stretch gap-3">
    <a class="heading-title-2">Overview</a>
    <div class="card light">
      <div class="content">
        <div class="v-stack gap-3">
          <a>Total overview</a>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Hours:</div>
            <div class="text-left">{{ data.hours }}</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Unsigned:</div>
            <div class="text-left">{{ data.unsigned }} (items)</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Revenue:</div>
            <div class="text-left">{{ format.currency(data.revenue) }} Kč</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Advance:</div>
            <div class="text-left">{{ format.currency(data.advance) }} Kč</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Balance:</div>
            <div class="text-left">{{ format.currency(data.balance) }} Kč</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import utils from "@/utils.js";
const moment = require("moment");

export default {
  data() {
    return {
      format: utils.format,
      data: {
        hours: 0,
        unsigned: 0,
        revenue: 0,
        advance: 0,
        balance: 0,
      },
    };
  },
  props: {
    selectedUser: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions(["getUserHoursOverview", "getWorkdays", "getOneTimePay"]),
    refresh() {
      this.getUserHoursOverview(this.selectedUser)
        .then((hours) => {
          this.data = hours;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
label,
input {
  align-self: center;
}
</style>
